import styled from 'styled-components';

const InfoHeader = styled.div`
    font-weight: 600;
    margin-bottom: 8px;
`;

export default InfoHeader;
